<template>
    <div class="flex flex-wrap items-center gap-1" role="group" :aria-label="trans('tasks.overview.filter.asset_type')">
        <button
            :aria-pressed="isAllActive"
            :class="isAllActive ? activeClass : inactiveClass"
            class="rounded-xl! border-2 px-4 py-3 text-sm leading-5 font-medium transition-colors focus-visible:outline-none"
            type="button"
            @click="selectAll"
        >
            {{ trans('general.action.all') }}
        </button>
        <button
            v-for="option in options"
            :key="option.value"
            v-c-tooltip="{ content: option.label, popperOptions: { positionFixed: true } }"
            :aria-label="option.label"
            :aria-pressed="isSelected(option.value)"
            :class="isSelected(option.value) ? activeClass : inactiveClass"
            class="rounded-xl! border-2 px-4 py-3 text-sm leading-5 font-medium transition-colors focus-visible:outline-none"
            type="button"
            @click="toggle(option.value)"
        >
            {{ option.shortLabel }}
        </button>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { trans } from '@/mixins/i18n';

const props = defineProps({
    options: {
        type: Array,
        required: true,
    },
    modelValue: {
        type: Array,
        default: () => [],
    },
});

const emit = defineEmits(['update:modelValue']);

const activeClass = 'border-primary bg-primary text-white';
const inactiveClass = 'border-panel-border bg-white text-gray-text hover:border-primary/50';

const isAllActive = computed(() => props.modelValue.length === 0);

const isSelected = (value) => props.modelValue.includes(value);

const selectAll = () => {
    emit('update:modelValue', []);
};

const toggle = (value) => {
    const current = [...props.modelValue];
    const index = current.indexOf(value);
    if (index === -1) {
        current.push(value);
    } else {
        current.splice(index, 1);
    }
    emit('update:modelValue', current);
};
</script>
